import { Button } from "@light-technology/components";
import { Plus } from "@untitledui/icons";
import { useState } from "react";
import { useDocumentTitle } from "../utilities/useDocumentTitle";
import { CreateAppModal } from "./CreateAppModal";

export const NoAppsPage = () => {
  useDocumentTitle("Apps");

  const [isCreate, setIsCreate] = useState(false);

  return (
    <div className="flex size-full flex-col items-center justify-center">
      <div className="text-md font-semibold">No apps found</div>
      <div className="mt-xs text-sm text-tertiary">
        Create an app to start development and customizing your brand's
        appearance.
      </div>
      <Button
        className="mt-3xl"
        iconLeading={Plus}
        onClick={() => {
          setIsCreate(true);
        }}
      >
        Create app
      </Button>
      <CreateAppModal isOpen={isCreate} setIsOpen={setIsCreate} />
    </div>
  );
};
